import React from "react";
import MFACodeForm from "./MFACodeForm";
import MFASetupSuccess from "./MFASetupSuccess";
import Stage from "./stage";
import EnforcedMFASetupFooter from "./EnforcedMFASetupFooter";

interface EnforcedMFASetupProps {
  afterSetupLocation: string;
}

interface EnforcedMFASetupState {
  stage: Stage;
}

export default class EnforcedMFASetup extends React.Component<
  EnforcedMFASetupProps,
  EnforcedMFASetupState
> {
  constructor(props: EnforcedMFASetupProps) {
    super(props);

    this.state = {
      stage: Stage.Code,
    };
  }

  render(): JSX.Element {
    return (
      <>
        <h1 className="form-panel__header is-left">{this.headerText}</h1>

        <div className="form-panel__form">
          {this.state.stage === Stage.Code ? (
            <MFACodeForm onSuccess={this.handleSubmitSuccess} />
          ) : (
            <MFASetupSuccess />
          )}
        </div>

        {this.state.stage === Stage.Success && (
          <EnforcedMFASetupFooter
            afterSetupLocation={this.props.afterSetupLocation}
          />
        )}
      </>
    );
  }

  handleSubmitSuccess = (): void => {
    this.setState({ stage: Stage.Success });
  };

  get headerText(): string {
    return this.state.stage === Stage.Code
      ? "Enable MFA for your account"
      : "MFA enabled!";
  }
}
